module.exports = __webpack_public_path__ + "img/wti_Logo2.d403044d.png";